$(document).ready(function() {
   $('.footer-block--menu h2.footer-block__heading').click(function() { 
      $(this).toggleClass("tab_active");
  });
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
  $(".abz-testimonial .regular").slick({
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="#000"></path></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="#000"></path></svg></button>',
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
    {
      breakpoint: 1099,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         adaptiveHeight: true,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  });
});
// $(window).scroll(function(){
//     if ($(this).scrollTop() > 20) {
//        $('.announcement-bar-section').addClass('annonce-fixed');
//     } else {
//        $('.announcement-bar-section').removeClass('annonce-fixed');
//     }
// });